module.exports = __webpack_public_path__ + "static/eu-flag-1d5466df3633b5c2adf2a0c0a61974f9.png";